/**
 * Route definition for /featured
 *
 * Displays a carousel-style showcase of featured NFT collections
 * using Three.js for a 3D interactive experience.
 * Fetches top collections from the backend sorted by popularity.
 *
 * @module routes/featured
 * @category Routes
 */

import { createFileRoute } from '@tanstack/react-router'
import FeaturedCarouselContainer from '@/containers/FeaturedCarousel'

export const Route = createFileRoute('/$locale/featured')({
  component: FeaturedCarousel,
})

/**
 * Featured collections carousel page component.
 *
 * @returns {React.ReactElement}
 */
function FeaturedCarousel() {
  return (
    <FeaturedCarouselContainer />
  )
}
